const replaceableSettings = ['embedLogos'];

export default function withReplace(oldValue, newValue, key) {
  if (_.includes(replaceableSettings, key)) {
    return newValue;
  }
}
